import React from 'react';
import { Query } from 'react-apollo';
import moment from 'moment';
import getOr from '~/util/getOr';

import NotFound from '~/components/NotFound/NotFound';
import GraphQLMatchupContainer from '~/containers/GraphQLMatchupContainer/GraphQLMatchupContainer';

import ScheduleQuery from '~/graphql/queries/leagueSchedule.graphql';

class GraphQLScheduleContainer extends React.Component {
  render() {
    let variables = {};

    if (this.props.league === 'pga' || this.props.league === 'lpga') {
      variables = {
        league: this.props.league,
        selected: this.props.selected,
      };
    }

    return (
      <Query query={ScheduleQuery} variables={variables}>
        {({ data, loading, error }) => {
          if (loading) return null;
          if (error) return <NotFound />;

          const schedule = getOr(data, 'leagues.0.schedule', []);

          const items = schedule.currentSeasonGroups.map(element => ({
            label: element.label,
            id: element.guid.split(':')[1],
            startDate: element.startDate,
            endDate: element.endDate,
          }));

          const inFuture = moment(this.props.selected, 'YYYY-MM').isAfter(
            moment(items[items.length - 1].id)
          );

          return (
            <GraphQLMatchupContainer
              league={this.props.league}
              after={this.props.selected}
              schedule={items}
              inFuture={inFuture}
            />
          );
        }}
      </Query>
    );
  }
}

export default GraphQLScheduleContainer;
